/* unplugin-vue-components disabled */import { render } from "./item-oral.vue?vue&type=template&id=b5632924"
import script from "./item-oral.vue?vue&type=script&lang=js"
export * from "./item-oral.vue?vue&type=script&lang=js"

import "./item-oral.vue?vue&type=style&index=0&id=b5632924&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__